import { IPaymentSettingsItem } from "web/types/Payment";

import { ProductToSeparateWithPaymentSettings } from "../types";
import sortRuleBankFrequency from "./sortRuleBankFrequency";
import sortRuleBankSub10Products from "./sortRuleBankSub10Products";
import sortRuleOnlineLast from "./sortRuleOnlineLast";
import sortRulePaymentSuggestion from "./sortRulePaymentSuggestion";
import sortRuleReset from "./sortRuleReset";

const sortRulesPipeline = [
  sortRulePaymentSuggestion,
  sortRuleBankSub10Products,
  sortRuleReset,
  sortRuleBankFrequency,
  sortRuleOnlineLast,
] as ((
  firstPayment: IPaymentSettingsItem,
  secondPayment: IPaymentSettingsItem,
  context?: {
    productCountByBankId: Record<string, number>;
    banksSub10Products: Set<string>;
    resetDateTimeByBankId: Record<string, number> | null;
    products: ProductToSeparateWithPaymentSettings[];
    product: ProductToSeparateWithPaymentSettings;
  }
) => number)[];

export default sortRulesPipeline;
